import EcoImg from 'eco-design/base/eco-img';
import React, { useEffect, useRef, useState } from 'react';
import useOpenAiChat from '@elem/compPage/chat/core/components/chat-icon/useOpenAiChat';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import gtm from '@/utils/gtm';
import EcoLink from 'eco-design/base/eco-link';

interface BottomActionProps {
    pageType: 'ultra' | 'max' | 'classic';
}

const BottomAction: React.FC<BottomActionProps> = ({ pageType } = { pageType: 'ultra' }) => {
    const { t } = useLang('BottomAction');
    const { locale = 'us' } = getLocal();

    /** 显示隐藏 */
    const [isLoaded, setIsLoaded] = useState(true);
    const [show, setShow] = useState(false);
    const divRef = useRef<HTMLDivElement>(null);

    const buyLink = {
        ultra: `https://${locale}.ecoflow.com/products/delta-3-ultra-series-portable-power-station`,
        max: `https://${locale}.ecoflow.com/products/delta-3-max-series-portable-power-station`,
        classic: `https://${locale}.ecoflow.com/products/delta-3-classic-portable-power-station`,
    };

    useEffect(() => {
        if (!divRef.current) return;

        let lastScrollY = window.scrollY;
        let ticking = false;

        const scrollHandler = () => {
            const currentScrollY = window.scrollY;
            const scrollDelta = currentScrollY - lastScrollY;

            // 向上滚动（scrollDelta > 0）隐藏，向下滚动（scrollDelta < 0）显示
            if (scrollDelta > 10) {
                setShow(true);
            } else if (scrollDelta < -10) {
                setShow(false);
            }

            lastScrollY = currentScrollY;
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                requestAnimationFrame(scrollHandler);
                ticking = true;
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
    // useEffect(() => {
    //     const handleLivechatReadyEvent = () => {
    //         setIsLoaded(true);
    //         setShow(true);
    //     };
    //     window.addEventListener('lcw:ready', handleLivechatReadyEvent);
    //     return () => window.removeEventListener('lcw:ready', handleLivechatReadyEvent);
    // }, []);

    const { handleOpenChat } = useOpenAiChat();

    const handleAi = () => {
        // (window as any).Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();

        handleOpenChat();

        gtm.push({
            __btn_id1: `${css.section} .action-ai`,
            __btn_id2: 'action-ai',
            __btn_type: 'common',
            __bth_only_ef: true,
        });
    };

    return (
        <div className={`${css.section} GtmModuleData-section ${show ? css.show : ''}`} data-section-id={'BottomAction'} ref={divRef}>
            <div className={`action action-ai GtmModuleData-btn-common ${isLoaded ? 'show' : 'hide'}`} data-btn-id="action-ai" onClick={handleAi}>
                <EcoImg className="icon-img" pc="https://websiteoss.ecoflow.com/upload/image/1759197671940/ai-icon.png" />
                <span>{t('ai')}</span>
            </div>
            {
                <EcoLink
                    className="action action-buy GtmModuleData-btn-common"
                    href={buyLink[pageType]}
                    dataLayer={{
                        __btn_id1: `${css.section} .action-buy`,
                        __btn_id2: 'action-buy',
                        __btn_type: 'common',
                    }}
                    data-btn-id="action-buy"
                >
                    <span>{t('buy')}</span>
                </EcoLink>
            }
        </div>
    );
};
export default BottomAction;
